(function () {
    var CFG = window.adexSearchConfig || { searchUrl: "/search", moneyFormat: "${{amount}}" };
    var overlay = document.querySelector("[data-search-overlay]");
    if (!overlay) return;

    var trigger = document.querySelector("[data-search-open]");
    var form = overlay.querySelector("[data-search-form]");
    var input = overlay.querySelector("[data-search-input]");
    var clearBtn = overlay.querySelector("[data-search-clear]");
    var tabsEl = overlay.querySelector("[data-search-tabs]");
    var statusEl = overlay.querySelector("[data-search-status]");
    var resultsEl = overlay.querySelector("[data-search-results]");
    var allLink = overlay.querySelector("[data-search-all]");

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var SEARCH_URL = CFG.searchUrl;
    var MONEY_FORMAT = CFG.moneyFormat;

    var TABS = [
      { key: "products", label: "Products", kind: "Product" },
      { key: "collections", label: "Collections", kind: "Collection" },
      { key: "pages", label: "Pages", kind: "Page" }
    ];

    var state = { q: "", data: null, active: "products", rows: [], idx: -1 };
    var timer = null;
    var controller = null;
    var lastFocus = null;

    /* ---------------- helpers ---------------- */
    function esc(s) {
      var t = String(s == null ? "" : s);
      var out = "";
      for (var i = 0; i < t.length; i++) {
        var c = t.charAt(i);
        if (c === "&") out += "&amp;";
        else if (c === "<") out += "&lt;";
        else if (c === ">") out += "&gt;";
        else if (c === String.fromCharCode(34)) out += "&quot;";
        else if (c === "'") out += "&#39;";
        else out += c;
      }
      return out;
    }
    function group(num, thousand, decimal, places) {
      var parts = num.toFixed(places).split(".");
      var whole = parts[0], i = whole.length, out = "";
      while (i > 3) { out = thousand + whole.slice(i - 3, i) + out; i -= 3; }
      out = whole.slice(0, i) + out;
      return parts.length > 1 ? out + decimal + parts[1] : out;
    }
    /* Predictive search returns decimal strings, so mirror the shop's
       money_format placeholders rather than assuming cents. */
    function money(dec) {
      var n = parseFloat(dec);
      if (!isFinite(n)) return "";
      var out = MONEY_FORMAT;
      var map = [
        ["amount_no_decimals_with_comma_separator", group(n, ".", "", 0)],
        ["amount_no_decimals_with_space_separator", group(n, " ", "", 0)],
        ["amount_with_period_and_space_separator", group(n, " ", ".", 2)],
        ["amount_with_apostrophe_separator", group(n, "'", ".", 2)],
        ["amount_with_comma_separator", group(n, ".", ",", 2)],
        ["amount_with_space_separator", group(n, " ", ",", 2)],
        ["amount_no_decimals", group(n, ",", "", 0)],
        ["amount", group(n, ",", ".", 2)]
      ];
      for (var i = 0; i < map.length; i++) {
        out = out.split("{{" + map[i][0] + "}}").join(map[i][1]);
        out = out.split("{{ " + map[i][0] + " }}").join(map[i][1]);
      }
      return out;
    }
    function sized(url, w) {
      if (!url) return "";
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
    }
    var GLYPH = {
      collection: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>',
      page: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>'
    };

    /* ---------------- rendering ---------------- */
    function rowProduct(p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || "";
      var price = parseFloat(p.price_min != null ? p.price_min : p.price);
      var cap = parseFloat(p.compare_at_price_max || 0);
      var varies = p.price_max != null && parseFloat(p.price_max) !== price;
      var onSale = isFinite(cap) && isFinite(price) && cap > price;
      var priceHtml = "";
      if (isFinite(price)) {
        priceHtml = '<span class="adex-srch__price' + (onSale ? " is-sale" : "") + '">' +
          (onSale ? "<s>" + money(cap) + "</s>" : "") +
          (varies && !onSale ? "From " : "") + money(price) + "</span>";
      }
      return '<a class="adex-srch__row" href="' + esc(p.url) + '">' +
        '<span class="adex-srch__thumb">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" loading="lazy">' : GLYPH.page) + "</span>" +
        '<span class="adex-srch__meta"><span class="adex-srch__title">' + esc(p.title) + "</span>" + priceHtml + "</span></a>";
    }
    function rowSimple(item, kind, glyph) {
      var img = item.image || (item.featured_image && item.featured_image.url) || "";
      var url = item.url || SEARCH_URL;
      var title = item.title || "";
      return '<a class="adex-srch__row" href="' + esc(url) + '">' +
        '<span class="adex-srch__thumb">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" loading="lazy">' : glyph) + "</span>" +
        '<span class="adex-srch__meta"><span class="adex-srch__title">' + esc(title) + "</span>" +
        '<span class="adex-srch__kind">' + esc(kind) + "</span></span></a>";
    }

    function render() {
      var d = state.data || {};
      var available = TABS.filter(function (t) { return (d[t.key] || []).length > 0; });

      if (!state.q) {
        tabsEl.setAttribute("hidden", "");
        allLink.setAttribute("hidden", "");
        resultsEl.innerHTML = "";
        statusEl.innerHTML = "";
        state.rows = [];
        return;
      }

      if (!available.length) {
        tabsEl.setAttribute("hidden", "");
        allLink.setAttribute("hidden", "");
        resultsEl.innerHTML = "";
        statusEl.innerHTML = "No results for <b>" + esc(state.q) + "</b> — try a chassis code like G80, or a part like lip.";
        state.rows = [];
        return;
      }

      /* Only show a tab when that resource type actually returned something. */
      if (!available.some(function (t) { return t.key === state.active; })) state.active = available[0].key;

      tabsEl.innerHTML = available.map(function (t) {
        var on = t.key === state.active;
        return '<button type="button" role="tab" class="adex-srch__tab" data-tab="' + t.key + '"' +
          ' id="adex-srch-tab-' + t.key + '" aria-controls="adex-srch-panel-' + t.key + '"' +
          ' aria-selected="' + (on ? "true" : "false") + '" tabindex="' + (on ? "0" : "-1") + '">' +
          esc(t.label) + '<span class="adex-srch__tab-n">' + (d[t.key] || []).length + "</span></button>";
      }).join("");
      tabsEl.removeAttribute("hidden");

      resultsEl.innerHTML = available.map(function (t) {
        var items = d[t.key] || [];
        var html = items.map(function (item) {
          if (t.key === "products") return rowProduct(item);
          if (t.key === "collections") return rowSimple(item, t.kind, GLYPH.collection);
          return rowSimple(item, t.kind, GLYPH.page);
        }).join("");
        return '<div class="adex-srch__group" role="tabpanel" id="adex-srch-panel-' + t.key + '"' +
          ' aria-labelledby="adex-srch-tab-' + t.key + '"' + (t.key === state.active ? "" : " hidden") + ">" + html + "</div>";
      }).join("");

      var activeTab = TABS.filter(function (t) { return t.key === state.active; })[0];
      var n = (d[state.active] || []).length;
      statusEl.innerHTML = n + " " + esc((activeTab && activeTab.label) || "").toLowerCase() +
        " for <b>" + esc(state.q) + "</b>";

      allLink.setAttribute("href", SEARCH_URL + "?q=" + encodeURIComponent(state.q));
      allLink.removeAttribute("hidden");

      state.idx = -1;
      state.rows = Array.prototype.slice.call(
        resultsEl.querySelectorAll('.adex-srch__group:not([hidden]) .adex-srch__row')
      );
    }

    /* ---------------- fetching ---------------- */
    function run(q) {
      if (controller) controller.abort();
      controller = ("AbortController" in window) ? new AbortController() : null;
      resultsEl.classList.add("is-loading");
      statusEl.innerHTML = "Searching…";

      var url = ROOT + "search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection,page" +
        "&resources[limit]=8" +
        "&resources[options][unavailable_products]=last" +
        "&resources[options][fields]=title,product_type,variants.title,vendor,tag";

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          state.q = q;
          state.data = (json && json.resources && json.resources.results) || {};
          resultsEl.classList.remove("is-loading");
          render();
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          resultsEl.classList.remove("is-loading");
          statusEl.innerHTML = "Search is unavailable right now. Press enter to search the full catalog.";
        });
    }

    function onInput() {
      var q = input.value.trim();
      if (q) clearBtn.removeAttribute("hidden"); else clearBtn.setAttribute("hidden", "");
      clearTimeout(timer);
      if (q.length < 2) {
        if (controller) controller.abort();
        state.q = q;
        state.data = null;
        resultsEl.classList.remove("is-loading");
        render();
        return;
      }
      timer = setTimeout(function () { run(q); }, 240);
    }

    /* ---------------- open / close ---------------- */
    function focusables() {
      return Array.prototype.filter.call(
        overlay.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return window.getComputedStyle(el).visibility !== "hidden" && !el.hasAttribute("hidden"); }
      );
    }
    function open() {
      if (!overlay.hasAttribute("hidden")) return;
      lastFocus = document.activeElement;
      overlay.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      if (overlay.hasAttribute("hidden")) return;
      overlay.setAttribute("hidden", "");
      document.body.style.overflow = "";
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      else if (trigger) trigger.focus();
    }

    function highlight(next) {
      if (!state.rows.length) return;
      if (state.idx > -1 && state.rows[state.idx]) state.rows[state.idx].classList.remove("is-active");
      state.idx = next < 0 ? -1 : next;
      if (state.idx < 0) { input.focus(); return; }
      if (state.idx >= state.rows.length) state.idx = state.rows.length - 1;
      var row = state.rows[state.idx];
      row.classList.add("is-active");
      row.focus({ preventScroll: false });
    }

    if (trigger) trigger.addEventListener("click", function (e) { e.preventDefault(); open(); });
    input.addEventListener("input", onInput);
    clearBtn.addEventListener("click", function () {
      input.value = "";
      clearBtn.setAttribute("hidden", "");
      state.q = ""; state.data = null;
      render();
      input.focus();
    });

    overlay.addEventListener("click", function (e) {
      if (e.target.closest("[data-search-close]")) { close(); return; }
      var tab = e.target.closest("[data-tab]");
      if (tab) {
        state.active = tab.getAttribute("data-tab");
        render();
        var btn = tabsEl.querySelector('[data-tab="' + state.active + '"]');
        if (btn) btn.focus();
      }
    });

    form.addEventListener("submit", function (e) {
      if (!input.value.trim()) e.preventDefault();
    });

    document.addEventListener("keydown", function (e) {
      if (overlay.hasAttribute("hidden")) return;

      if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); close(); return; }

      if (e.key === "ArrowDown") { e.preventDefault(); highlight(state.idx + 1); return; }
      if (e.key === "ArrowUp") { e.preventDefault(); highlight(state.idx - 1); return; }

      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        if (!e.target.closest("[data-tab]")) return;
        e.preventDefault();
        var keys = Array.prototype.map.call(tabsEl.querySelectorAll("[data-tab]"), function (b) { return b.getAttribute("data-tab"); });
        var i = keys.indexOf(state.active);
        state.active = keys[(i + (e.key === "ArrowRight" ? 1 : keys.length - 1)) % keys.length];
        render();
        var btn = tabsEl.querySelector('[data-tab="' + state.active + '"]');
        if (btn) btn.focus();
        return;
      }

      if (e.key !== "Tab") return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    });
  })();